<ng-container *ngIf="accessDenied">
    <p>{{ 'FEATURES.AGREEMENTS.ACCESS_DENIED' | translate }}</p>
</ng-container>
<div class="page-title" *ngIf="!initialLoad && !accessDenied">
    <div class="header">
        <h1>{{ title }} : {{ agreementName }}</h1>
        <div *ngIf="!disabled" class="renegotiate-info">
            <span *ngIf="sentForRenegotiateDate"
                >({{ 'FEATURES.AGREEMENTS.RENEGOTIATE.SENT' | translate }}:
                {{ sentForRenegotiateDate | date: 'yyyy-MM-dd' }})</span
            >
            <button
                (click)="renegotiateAgreement($event)"
                class="renegotiate"
                [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.RENEGOTIATE' | translate"
                [tooltipPosition]="'left'"
            >
                <span>{{ 'BUTTONS.RENEGOTIATE' | translate }}</span>
            </button>
        </div>
    </div>

    <div class="info-items">
        <div *ngIf="showInfo" [ngClass]="warningDaysToLastDateForNotice ? 'reminderWarning' : 'infoItem'">
            <div>
                <span class="material-symbols-rounded" aria-hidden="true">error</span>
                {{
                    'FEATURES.AGREEMENTS.LAST_DATE_FOR_NOTICE_TITLE'
                        | translate: { days: daysToLastDateForNotice, date: lastDateForNotice }
                }}
            </div>
            <button *ngIf="!disabled" (click)="goToPeriodAndRenewalsTab($event)">
                <span>{{ 'BUTTONS.MANAGE' | translate }}</span>
            </button>
        </div>
        <div *ngIf="isTerminated && daysToLastDateForTermination > 0" class="reminderWarning">
            <div>
                <span class="material-symbols-rounded" aria-hidden="true">error</span>
                {{
                    'FEATURES.AGREEMENTS.LAST_DATE_TO_TERMINATION_TITLE'
                        | translate: { days: daysToLastDateForTermination, date: lastDateForTermination }
                }}
            </div>
        </div>
        <div *ngIf="isTerminated" class="infoItem">
            <div>
                <span class="material-symbols-rounded" aria-hidden="true">check_circle</span>
                {{
                    ('FEATURES.AGREEMENTS.TERMINATED' | translate) +
                        ' ' +
                        (isTerminated ? '(' + (terminated | date: 'yyyy-MM-dd') + ')' : '')
                }}
            </div>
        </div>
        <div *ngIf="isManaged" class="infoItem">
            <div>
                <span class="material-symbols-rounded" aria-hidden="true">check_circle</span>
                {{
                    ('FEATURES.AGREEMENTS.MANAGED' | translate) +
                        ' ' +
                        (isManaged ? '(' + (managed | date: 'yyyy-MM-dd') + ')' : '')
                }}
            </div>
        </div>
    </div>
</div>

<app-form-container-centered>
    <ng-container *ngIf="!initialLoad && !accessDenied; else loadingTemplate">
        <app-tabset [destroyOnHide]="true" #tabset>
            <app-tab [title]="'FEATURES.AGREEMENTS.TAB_SUMMARY' | translate">
                <ng-template appTabContent>
                    <app-agreement-summary-info [agreementForm]="agreementForm"></app-agreement-summary-info>
                </ng-template>
            </app-tab>
            <app-tab [title]="'FEATURES.AGREEMENTS.TAB_GENERAL_INFO' | translate">
                <ng-template appTabContent>
                    <app-agreement-details
                        [agreementForm]="agreementForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-details>
                </ng-template>
            </app-tab>
            <app-tab [title]="'FEATURES.AGREEMENTS.TAB_PERIODS_RENEWALS' | translate">
                <ng-template appTabContent>
                    <app-agreement-periods-renewals
                        [agreementForm]="agreementForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-periods-renewals>
                </ng-template>
            </app-tab>
            <app-tab *ngIf="hasRiskAnalysis" [title]="'FEATURES.AGREEMENTS.TAB_RISK_ANALYSIS' | translate">
                <ng-template appTabContent>
                    <app-agreement-risk-analysis [agreementForm]="agreementForm"></app-agreement-risk-analysis>
                </ng-template>
            </app-tab>
        </app-tabset>
        <div [appTabsetOutlet]="tabset"></div>
    </ng-container>
    <ng-template #loadingTemplate>
        <div *ngIf="!hasError && !accessDenied">
            <app-spinner />
        </div>
    </ng-template>
    <ng-container footer>
        <ng-container *ngIf="!initialLoad">
            <div class="button-right-container">
                <ng-container *ngIf="footerTemplateRef">
                    <ng-container *ngTemplateOutlet="footerTemplateRef" />
                </ng-container>
                <button
                    *ngIf="hasNewPdf"
                    [disabled]="generatingMetaData || !hasAITokens"
                    (click)="generateMetaData($event, true)"
                    class="icon"
                    [title]="getGenerateMetaDataTooltip()"
                    [ngClass]="{ loading: generatingMetaData }"
                >
                    <span>{{ 'BUTTONS.GENERATE_METADATA' | translate }}</span>
                </button>
                <button
                    *ngIf="canGenerateRiskAnalysis"
                    [disabled]="generatingMetaData || !hasAITokens"
                    (click)="generateMetaData($event, false, true)"
                    class="icon"
                    [title]="getGenerateMetaDataTooltip()"
                    [ngClass]="{ loading: generatingMetaData }"
                >
                    <span>{{ 'BUTTONS.GENERATE_RISK_ANALYSIS' | translate }}</span>
                </button>
            </div>
        </ng-container>
    </ng-container>
</app-form-container-centered>
